import React, { ReactNode } from "react";
import styles from "./badge.module.scss";

export type BadgeProps = {
  size?: "small" | "xsmall" | "tiny";
  emphasis?: "default" | "primary" | "secondary";
  type?: "solid" | "outline";
  children: ReactNode;
  theme?: "core" | "trainer";
} & React.HTMLAttributes<HTMLDivElement>;

const Badge = ({
  size = "small",
  emphasis = "default",
  type = "solid",
  children,
  theme = "core",
  ...props
}: BadgeProps) => (
  <div
    {...props}
    className={`${styles.badge} ${props.className}`}
    data-size={size}
    data-emphasis={emphasis}
    data-type={type}
    data-theme={theme}
  >
    {children}
  </div>
);

export default Badge;
